import { useQuery } from '@tanstack/react-query';
import { chestService, type UnopenedChest } from '@services';

interface UseUnopenedChestsResult {
  unopenedChests: UnopenedChest[];
  total: number;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const UNOPENED_CHESTS_QUERY_KEY = ['unopened-chests'] as const;

export const useUnopenedChests = (): UseUnopenedChestsResult => {
  const {
    data: unopenedChests = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: UNOPENED_CHESTS_QUERY_KEY,
    queryFn: async () => {
      const data = await chestService.getUnopenedChests();
      return data || [];
    },
    staleTime: 1000 * 30,
    gcTime: 1000 * 60 * 5,
  });

  return {
    unopenedChests,
    total: unopenedChests.length,
    isLoading,
    error: error as Error | null,
    refetch,
  };
};
